import getFilterAction from "./AddFilterAction/actions";
import getSortAction from "./AddSortAction/actions";
import { Operator } from "./operators";
import { ActionDef, ActionKind, HydratedAction, Schema } from "./shared";

// Hydrates the serialized representation into either a HydratedFilterAction or HydratedSortAction
export const hydrateAction = (action: ActionDef, schema: Schema): HydratedAction => {
  if (action.kind === ActionKind.Filter) {
    return getFilterAction(
      schema,
      action.jsonKey,
      action.operator as Operator,
      action.comparisonValue,
    );
  }

  if (action.kind === ActionKind.Sort) {
    return getSortAction(schema, action.jsonKey, action.sortOrder);
  }

  throw new Error("Action kind invalid.");
};
export const hydrateActions = (actions: ActionDef[], schema: Schema): HydratedAction[] =>
  actions.map(a => hydrateAction(a, schema));

// Dehydrates the action into its base parameters
export const dehydrateAction = (action: HydratedAction) => {
  let dehydrated;
  if (action.kind === ActionKind.Filter) {
    dehydrated = {
      kind: action.kind,
      jsonKey: action.jsonKey,
      operator: action.operator,
      comparisonValue: action.comparisonValue || "",
    };

    // For values not requiring a comparison value, just delete the key
    if (dehydrated.comparisonValue === "") {
      delete dehydrated.comparisonValue;
    }
  }

  if (action.kind === ActionKind.Sort) {
    dehydrated = {
      kind: action.kind,
      jsonKey: action.jsonKey,
      sortOrder: action.sortOrder,
    };
  }

  return dehydrated;
};
export const dehydrateActions = (actions: HydratedAction[]): ActionDef[] =>
  actions.map(a => dehydrateAction(a));
